import { defineStore } from 'pinia'
import { ref } from 'vue'
import { watermarkApi } from '@/api/watermark'

export const useWatermarkStore = defineStore('watermark', () => {
  // ==================== 去除水印（全局开关，需跨页面同步） ====================
  const removeWatermarkEnabled = ref(localStorage.getItem('remove_watermark_enabled') === 'true')

  const setRemoveWatermarkEnabled = (enabled: boolean) => {
    removeWatermarkEnabled.value = enabled
    localStorage.setItem('remove_watermark_enabled', enabled ? 'true' : 'false')
  }

  const syncRemoveWatermarkFromStorage = () => {
    removeWatermarkEnabled.value = localStorage.getItem('remove_watermark_enabled') === 'true'
  }

  const resetRemoveWatermark = () => {
    removeWatermarkEnabled.value = false
  }

  // ==================== 品牌水印规则（原有逻辑） ====================
  const rules = ref<any | null>(null)
  const loading = ref(false)
  const loaded = ref(false)

  const fetchRules = async (force = false) => {
    if (loading.value) return
    if (loaded.value && !force && rules.value) return

    loading.value = true
    try {
      const res = await watermarkApi.findBrandWatermarkRules()
      if (res?.resp_code === 0 && res.datas) {
        rules.value = res.datas
        loaded.value = true
      }
    } catch (error) {
      console.error('[watermarkStore] 获取品牌水印配置规则失败:', error)
      // 出错时不标记 loaded，方便下次重试
    } finally {
      loading.value = false
    }
  }

  const resetRules = () => {
    rules.value = null
    loaded.value = false
  }

  return {
    // 去除水印全局开关
    removeWatermarkEnabled,
    setRemoveWatermarkEnabled,
    syncRemoveWatermarkFromStorage,
    resetRemoveWatermark,

    rules,
    loading,
    loaded,
    fetchRules,
    resetRules,
  }
})
